import * as React from 'react'

import { Box, Section, Text } from '@factorialco/deprecated-design-system'

import Callout from 'modules/core/components/Callout'
import i18n from 'modules/core/lib/i18n'

import Accrues from 'modules/timeoff/components/LeaveTypeSettings/LeaveTypes/UpsertLeaveType/Content/Accrues'
import Payable from 'modules/timeoff/components/LeaveTypeSettings/LeaveTypes/UpsertLeaveType/Content/Payable'
import Workable from 'modules/timeoff/components/LeaveTypeSettings/LeaveTypes/UpsertLeaveType/Content/Workable'
import type LeaveTypeFormModel from 'modules/timeoff/lib/LeaveTypeForm'

interface Props {
  leaveTypeForm: LeaveTypeFormModel
  canEditDetails: boolean
}

const AllowanceSection = ({ leaveTypeForm, canEditDetails }: Props) => {
  const [isWorkable, setIsWorkable] = React.useState<boolean>(leaveTypeForm.get('workable').value)
  const [isPayable, setIsPayable] = React.useState<boolean>(leaveTypeForm.get('payable').value)

  const handleAccruesChange = (value: boolean) => {
    leaveTypeForm.setValues({ accrues: value })
  }

  const handleWorkableChange = (value: boolean) => {
    setIsWorkable(value)
    setIsPayable(false)
    leaveTypeForm.setValues({ workable: value, payable: false })
  }

  const handlePayableChange = (value: boolean) => {
    setIsPayable(value)
    setIsWorkable(false)
    leaveTypeForm.setValues({ payable: value, workable: false })
  }

  const icon = 'holidays-event-go'
  const title = i18n.t('settings.leave_types.page.allowance.title')
  const description = i18n.t('settings.leave_types.page.allowance.description')

  const [showCallout, setShowCallout] = React.useState<boolean>(true)

  const calloutTitle = i18n.t('settings.leave_types.page.allowance.callout.title')
  const calloutDescription = i18n.t('settings.leave_types.page.allowance.callout.description')

  return (
    <Section
      illustration={icon}
      title={title}
      description={description}
      banner={
        <>
          {showCallout && (
            <Box style={{ maxWidth: '500px' }}>
              <Callout
                type="info"
                title={calloutTitle}
                description={calloutDescription}
                onRemove={() => setShowCallout(false)}
              />
            </Box>
          )}
        </>
      }
    >
      <Box gap="s24">
        <Accrues
          readonly={!canEditDetails}
          field={leaveTypeForm.get('accrues')}
          onChange={handleAccruesChange}
        />
        <Box gap="s8">
          <Payable value={isPayable} onChange={handlePayableChange} />
          <Text.Normal size="100">
            {i18n.t('settings.leave_types.page.allowance.form.payable.note')}
          </Text.Normal>
        </Box>
        <Box gap="s8">
          <Workable value={isWorkable} onChange={handleWorkableChange} />
          <Text.Normal size="100">
            {i18n.t('settings.leave_types.page.allowance.form.workable.note')}
          </Text.Normal>
        </Box>
      </Box>
    </Section>
  )
}

export default AllowanceSection
